import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { apiParameters } from 'src/app/configs/api.params';

@Injectable({
  providedIn: 'root'
})

export class CollageService {

  public apiEndPoint = apiParameters.url;
  // public apiParam = '/users/7';

  constructor(private httpClient: HttpClient) { }

  /**
   * Gets user collages
   * @param userId - user id
   * @returns user collages 
   */
  getUserCollages(userId: string): Observable<any> {
    const url = apiParameters.url + '/users/' + userId + '/collages';
    return this.httpClient.get(url);
  }
  
  /**
   * Adds new user collage
   * @param userId - user id
   * @param body - collage data
   * @returns user collage 
   */
  addUserCollage(userId: string, body): Observable<any> {
    const url = apiParameters.url + '/users/' + userId + '/collages';
    return this.httpClient.post(url, body);
  }

  editCollage(userId: string, collageId: string, body): Observable<any> {
    const url = apiParameters.url + '/users/' + userId + '/collages/' + collageId;
    return this.httpClient.patch(url, body);
  }

  deleteCollage(userId: string, collageId: string): Observable<any> {
    const url = apiParameters.url + '/users/' + userId + '/collages/' + collageId ;
    return this.httpClient.delete(url);
  }

  addCollageFile(userId: string, collageId: string, body): Observable<any> {
    const url = apiParameters.url + '/users/' + userId + '/collages/' + collageId + '/files';
    return this.httpClient.post(url, body);
  }

  deleteCollageFile(userId: string, collageId: string, fileId: string): Observable<any> {
    const url = apiParameters.url + '/users/' + userId + '/collages/' + collageId + '/files/' + fileId;
    return this.httpClient.delete(url);
  }

  unassignCollage(userId: string, collageId: string, presetId: string, settingsId?: string): Observable<any> {
    let searchParams = new HttpParams();

    if (settingsId && settingsId !== '') {
      searchParams = searchParams.append('profileId', settingsId);
    }

    const httpOptions = {
      headers: new HttpHeaders({}),
      params: searchParams
    };

    const url = apiParameters.url + '/users/' + userId + '/collages/' + collageId + '/presets/' + presetId ;
    return this.httpClient.delete(url, httpOptions);
  }

  assignCollage(userId: string, collageId: string, body, settingsId?: string): Observable<any> {
    let searchParams = new HttpParams();

    if (settingsId && settingsId !== '') {
      searchParams = searchParams.append('profileId', settingsId);
    }

    const httpOptions = {
      headers: new HttpHeaders({}),
      params: searchParams
    };

    const url = apiParameters.url + '/users/' + userId + '/collages/' + collageId + '/presets/' ;
    return this.httpClient.post(url, body, httpOptions);
  }

  updateAssignedCollage(userId: string, collageId: string, presetId: string, body, settingsId?: string): Observable<any> {
    let searchParams = new HttpParams();

    if (settingsId && settingsId !== '') {
      searchParams = searchParams.append('profileId', settingsId);
    }

    const httpOptions = {
      headers: new HttpHeaders({}),
      params: searchParams
    };

    const url = apiParameters.url + '/users/' + userId + '/collages/' + collageId + '/presets/' + presetId ;
    return this.httpClient.patch(url, body, httpOptions);
  }
}
